import { TIME_RESEND_EMAIL_SECOND } from 'constants';

import React, { useEffect, useState } from 'react';

import { useFormik } from 'formik';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { resetPassword } from 'api/endpoints/auth';
import Button from 'components/Button';
import ErrorMessage from 'components/ErrorMessage';
import Input from 'components/Input';
import TitleInput from 'components/TitleInput';
import LOCAL_STORAGE_KEYS from 'constants/localStorageKeys';
import { toastError, toastSuccess } from 'lib/toast';
import { validateEmail, isFullWidth, validateJapanese } from 'utils/helper';
import { getFromLocalStorage, saveToLocalStorage } from 'utils/localStorage';

const EnterEmailInfomation = () => {
  const { t } = useTranslation();
  const [second, setSecond] = useState(0);
  const [intervalFnc, setIntervalFnc] = useState(null);
  const [emailInValidJapan, setEmailInValidJapan] = useState(false);
  const initialValues = {
    email: '',
  };

  /**
   * This function is hit when clicking Submit Success
   * @param {*} time
   */
  const saveEmailSend = (time) => {
    if (time === TIME_RESEND_EMAIL_SECOND) {
      saveToLocalStorage(LOCAL_STORAGE_KEYS.SEND_EMAIL_FORGOT_PASSWORD, { time: moment().unix(), email: form.values.email });
    }
  };

  /**
   * The countdown function sends the mail
   * If the mail check has already been sent, then transmitted it to the previous time
   * If sent new, then transmitted TIME_RESEND_EMAIL_SECOND
   * @param {*} _time
   */
  const countDown = (_time = TIME_RESEND_EMAIL_SECOND) => {
    saveEmailSend(_time);

    // Countdown
    let time = _time;
    const timeItv = setInterval(() => {
      if (time > 0) {
        time--;
        setSecond(() => time);
      } else {
        clearInterval(intervalFnc);
      }
    }, 1000);

    setIntervalFnc(timeItv);
  };

  const form = useFormik({
    initialValues: initialValues,
    validateOnChange: true,
    validateOnBlur: false,
    validate: (values) => {
      const errors = {};

      if (values.email && (isFullWidth(values.email) || validateJapanese(values.email))) {
        errors.email = true;
        setEmailInValidJapan(true);
      } else if (!values.email || !validateEmail(values.email)) {
        errors.email = true;
        setEmailInValidJapan(false);
      } else {
        setEmailInValidJapan(false);
      }

      const resetPassword = getFromLocalStorage(LOCAL_STORAGE_KEYS.SEND_EMAIL_FORGOT_PASSWORD);

      if (resetPassword) {
        const timeBeforeReload = moment().unix() - resetPassword.time;
        if (timeBeforeReload < TIME_RESEND_EMAIL_SECOND) {
          // Continue to count down to the present time
          countDown(60 - timeBeforeReload);
          setSecond(60 - timeBeforeReload);
        } else {
          setSecond(0);
          clearInterval(intervalFnc);
        }
      }
      return errors;
    },
    onSubmit: async (values) => {
      try {
        await resetPassword(values)
          .then((response) => {
            toastSuccess(response.message);
            countDown(TIME_RESEND_EMAIL_SECOND);
            setSecond(TIME_RESEND_EMAIL_SECOND);
          })
          .catch((errors) => {
            toastError(errors?.message);
          });
      } catch {
        // Handle error
      }
    },
  });

  useEffect(() => {
    const resetPassword = getFromLocalStorage(LOCAL_STORAGE_KEYS.SEND_EMAIL_FORGOT_PASSWORD);

    if (resetPassword) {
      const timeBeforeReload = moment().unix() - resetPassword.time;
      if (timeBeforeReload < TIME_RESEND_EMAIL_SECOND) {
        // Continue to count down to the present time
        countDown(60 - timeBeforeReload);
        setSecond(60 - timeBeforeReload);
      } else {
        setSecond(0);
        clearInterval(intervalFnc);
      }
    }
  }, []);

  return (
    <>
      <fieldset>
        <TitleInput text={t('EMAIL_ADDRESS')} required={true} className="!mt-0" />
        <Input
          id="email"
          type="text"
          name="email"
          value={form.values.email}
          onChange={form.handleChange}
          placeholder={t('PLACEHOLDER_EMAIL')}
          invalid={form.errors.email}
        />
        <p className={`text-sm ${form.errors.email || emailInValidJapan ? 'text-danger-229' : 'text-secondary-354'}`}>
          {!form.values.email && form.errors.email && <ErrorMessage>{t('NOT_EMPTY')}</ErrorMessage>}
          {form.values.email ? (
            emailInValidJapan ? (
              <ErrorMessage>{t('EMAIL_INVALID_FORMAT')}</ErrorMessage>
            ) : (
              form.errors.email && <ErrorMessage>{t('INVALID_EMAIL')}</ErrorMessage>
            )
          ) : (
            <></>
          )}
          {!form.errors.email && !emailInValidJapan && t('REQUIRED_EMAIL_TEXT')}
        </p>
      </fieldset>

      <Button
        onClick={() => {
          if (form.values.email && !form.errors.email && second === 0) {
            form.handleSubmit();
          }
        }}
        className={`w-60 h-9.5 mt-8 mx-auto ${form.values.email && !form.errors.email && second === 0 ? '' : 'bg-white-795 text-black/25 cursor-not-allowed'}`}
        color={form.values.email && !form.errors.email && second === 0 ? 'primary' : 'outline'}
        type="button"
        text={t('SEND_EMAIL')}
      />
      {second > 0 && (
        <p className="text-sm text-center text-primary-346 mt-2">
          {second}
          {t('RESEND_LATER')}
        </p>
      )}
      <p className="text-black-102 text-sm text-center mt-4">{t('SEND_TO_EMAIL_ABOVE')}</p>
    </>
  );
};

export default React.memo(EnterEmailInfomation);
